// api
// import api from '../api'
import * as types from './mutation-types'

// app methods
export const saveSize = ({commit}, size) => {
	commit(types.RESIZE, size)
}

export const appFetched = ({commit}) => {
	commit(types.APP_FETCHED)
}



// WEBPACK FOOTER //
// ./src/vuex/actions.js